module.exports = __webpack_public_path__ + "img/61_1.20685b22.jpg";